module.exports = __webpack_public_path__ + "img/developer.6303b5e5.png";